export default Object.freeze({
  Details: 0,
  StartOrContinue: 1,
});
